import React from 'react';
import { Box, Button, Icon, Typography } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../utils';
import { type Provider, providers } from '../constants';

import invertedMessages from './messages';

import './SetUpIdProofing.css';

interface SetUpIdProofingProps {
  setIsOpen: (val: boolean) => void;
  setCurrentVendor: (val: Provider) => void;
  setIsIDDataWeb: (val: boolean) => void;
  setIsKosmos: (val: boolean) => void;
}

function SetUpIdProofing({
  setIsOpen,
  setCurrentVendor,
  setIsIDDataWeb,
  setIsKosmos,
}: SetUpIdProofingProps) {
  const l = useInvertedLocalize(invertedMessages);

  return (
    <Box className='Ext-SetUpIdProofing'>
      <Typography
        kind='display'
        color='--color-foreground-secondary-bold'
        className='Ext-SetUpIdProofing-title'>
        {l('Set Up ID Proofing Today to Boost Security')}
      </Typography>
      <Box className='Ext-SetUpIdProofing-chooseProvider'>
        <Typography kind='h2' color='--color-foreground-neutral-bold'>
          {l('Choose a provider')}
        </Typography>
      </Box>
      <div className='Ext-SetUpIdProofing-providers'>
        {providers.map((item) => (
          <Box
            className='Ext-SetUpIdProofing-providers-card'
            dataTestId={item.id}
            key={item.id}>
            <Icon
              kind={item.icon}
              className='Ext-SetUpIdProofing-providers-card-icon'
            />
            <Typography kind='h3' color='--color-foreground-neutral-bold'>
              {item.name}
            </Typography>
            <Button
              type='button'
              kind='subtle'
              className='Ext-SetUpIdProofing-providers-btn'
              onClick={() => {
                setIsOpen(true);
                setCurrentVendor(item);

                if (item.id === 'IDDATAWEB') {
                  setIsIDDataWeb(true);
                }

                if (item.id === '1KOSMOS') {
                  setIsKosmos(true);
                }
              }}>
              {l('Set Up')}
            </Button>
          </Box>
        ))}
      </div>
    </Box>
  );
}

export default SetUpIdProofing;
